import React from "react";
import Link from "next/link";
import Image from "next/image";
import { getImageSrc } from "@/app/utils/getImageSrc";
export const TenderCard = ({ title, link = "#" }) => {
    return (
        <Link
            href={getImageSrc(link)}
            target="_blank"
            className="bg-white rounded-[15px] px-6 py-2.5 flex justify-between items-center border border-[#E2E2E2]"
        >
            <h4 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-medium text-black">
                {title}
            </h4>
            <div className="bg-primary rounded-full p-2 tender-btn">
                <Image
                    alt="Download tender document icon"
                    src="./download.svg"
                    width={16}
                    height={16}
                    unoptimized
                    className="object-contain"
                />
            </div>
        </Link>
    );
};
